const styles = {
  container: {
    padding: 0
  }
};

export default styles;
